module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExEditable,
      "code": _vm.ExEditableCode,
      "title": "Editable (non readonly)",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Use "), _c('code', [_vm._v("editable")]), _vm._v(" prop to let the user type a time.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExRange,
      "code": _vm.ExRangeCode,
      "title": "Range",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can limit the date range with "), _c('code', [_vm._v("min-time")]), _vm._v(" and "), _c('code', [_vm._v("max-time")]), _vm._v(" props.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFooter,
      "code": _vm.ExFooterCode,
      "title": "Footer",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Any slots are added to the footer of the timepicker.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExInline,
      "code": _vm.ExInlineCode,
      "title": "Inline",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Timepicker can also be shown inline with the "), _c('code', [_vm._v("inline")]), _vm._v(" prop, input is removed, set a "), _c('code', [_vm._v("v-model")]), _vm._v(" to get the date.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04317366"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/timepicker/Timepicker.vue
// module id = 1564
// module chunks = 15